export const products = {
  title: 'Products and services',
  subtitle: 'Manage and overview products',
  organizations: "All organizations",
  new: "New product",
  loading: "Loading products...",
  noResults: "No results found",
  tryDifferentSearch: "Try different search criteria",
  filter: {
    allTypes: "All types",
    products: "Products",
    services: "Services",
    packages: "Packages",
    category: "Category",
    active: "Active filters"
  },
  types: {
    product: "Product",
    service: "Service",
    package: "Package"
  },
  fields: {
    product: "Product",
    type: "Type",
    organizations: "Organizations",
    price: "Price",
    actions: "Actions",
    tax: "% Tax",
    category: "Category",
    category1: "Main Category",
    category2: "Subcategory",
    status: "Status",
    active: "Active",
    name: "Name",
    code: "Code",
    description: "Description",
    unit: "Unit",
    netPrice: "Net Price",
    grossPrice: "Gross Price",
    taxRate: "Tax Rate",
    rounding: "Rounding",
    webStore: "Web Store",
    discontinued: "Discontinued",
    reverseTaxation: "Reverse Taxation",
    productImage: "Product Image",
    thumbnailImage: "Thumbnail Image",
    stock: "Stock",
    articleNumber: "Article Number",
    barcode: "Barcode",
    vtsz: "VTSZ/TESZOR code",
    purchasePrice: "Purchase Price",
    accountingPrice: "Accounting Price"
  },
  sections: {
    details: "Product Details",
    categories: "Categories",
    pricing: "Pricing",
    additionalPricing: "Additional Pricing Options",
    images: "Product Images",
    productImages: "Product Images",
    hiddenImages: "Hidden Images (Admin Only)",
    additionalImages: "Additional Images",
    inventory: "Inventory Summary",
    inventoryDetails: "Inventory Details",
    stockMovements: "Stock Movements"
  },
  validation: {
    nameRequired: "Name is required",
    codeRequired: "Code is required",
    codeAvailable: "✓ Code is available",
    codeInUse: "❌ Code is already in use",
    codeCheckInProgress: "Checking code availability...",
    waitForCodeCheck: "Please wait for code validation to complete.",
    codeAlreadyInUse: "Product code is already in use. Please choose a different code."
  },
  units: {
    piece: "Piece",
    kg: "Kilogram",
    liter: "Liter",
    meter: "Meter",
    package: "Package",
    box: "Box",
    hour: "Hour",
    day: "Day",
    month: "Month"
  },
  tooltips: {
    duplicate: "Create duplicate",
    edit: "Edit",
    delete: "Delete",
    view: "View details",
    copy: "Copy",
    inventory: "View inventory"
  },
  messages: {
    deleteConfirm: 'Are you sure you want to delete this product?',
    noMoreOrgs: 'No more organizations to add',
    confirmTitle: 'Product deletion',
    deleteQuestion: 'Are you sure you want to delete this product?',
    deleteWarning: 'This action cannot be undone.'
  },
  copy: "Copy",
  edit: "Edit",
  delete: "Delete",
  view: "View",
  inventory: "Inventory",
  moreActions: "More actions",
  deactivate: "Deactivation",
  noCategories: "No categories available",
  noSubcategories: "No subcategories available",
  selectedCategory: "Selected category",
  uploadImage: "Upload image",
  uploadingImage: "Uploading image...",
  imageInstructions: "The image must be in JPG or PNG format, max. 5MB in size.",
  form: {
    add: "Create new product",
    edit: "Edit product",
    type: {
      title: "Product type",
      product: "Product",
      service: "Service",
      package: "Package"
    },
    package: {
      includedInPrice: "Included in price"
    },
    basicInfo: {
      title: "Product data",
      name: "Name",
      code: "Code",
      description: "Description",
      unit: "Unit",
    },
    pricing: {
      title: "Organization and pricing",
      price: "Price",
      currency: "Currency",
      taxRate: "Tax rate (%)",
    },
    selectCategory: "Select main category",
    selectSubcategory: "Select subcategory",
    selectTaxRate: "Select tax rate",
    buttons: {
      add: "Add product",
      update: "Update product",
      cancel: "Cancel",
      remove: "Remove"
    }
  }
}